// extracted by mini-css-extract-plugin
export var addressCard = "_15-4";
export var addressFields = "_15-1p";
export var addressText = "_15-x";
export var adjustment = "_15-1t";
export var adjustmentBonus = "_15-1k";
export var adjustmentFee = "_15-1l";
export var bonus = "_15-1h";
export var brand = "_15-g";
export var button = "_15-13";
export var card = "_15-j";
export var cardImage = "_15-q";
export var cardInformation = "_15-k";
export var cardItemTitle = "_15-1n";
export var cardItems = "_15-v";
export var cards = "_15-i";
export var center = "_15-b";
export var code = "_15-l";
export var contentWrapper = "_15-1";
export var covered = "_15-f";
export var edit = "_15-1o";
export var error = "_15-14";
export var exchangeBox = "_15-1e";
export var exchangeBoxSelected = "_15-1f";
export var exchangeBoxes = "_15-1d";
export var fee = "_15-1i";
export var flex = "_15-z";
export var greenReturnAdjustment = "_15-1j";
export var infoIcon = "_15-m";
export var input = "_15-12";
export var inputRow = "_15-11";
export var left = "_15-c";
export var leftContent = "_15-2";
export var line = "_15-10";
export var logo = "_15-h";
export var modal = "_15-o";
export var modalContainer = "_15-n";
export var modalTitle = "_15-p";
export var orderMethodText = "_15-1g";
export var page = "_15-0";
export var pickupButton = "_15-t";
export var pickupForm = "_15-8";
export var pickupInputDescription = "_15-1b";
export var pickupLocationDropdown = "_15-1q";
export var pickupPrice = "_15-s";
export var price = "_15-r";
export var reminderTextItem = "_15-1r";
export var returningDisclaimer = "_15-y";
export var subheader = "_15-w";
export var summaryCard = "_15-5";
export var summaryCardContent = "_15-9";
export var summaryCardHorizonal = "_15-6";
export var summaryCardItem = "_15-a";
export var summaryCardItemHorizontal = "_15-d";
export var summaryCardItemPayment = "_15-e";
export var summaryCardPickup = "_15-7";
export var summaryCards = "_15-3";
export var summaryDisclaimer = "_15-1a";
export var summaryHeader = "_15-15";
export var summarySubheader = "_15-16";
export var summarySubtext = "_15-1c";
export var summaryText = "_15-17";
export var summaryTextBold = "_15-19";
export var summaryTextLight = "_15-18";
export var title = "_15-1s";
export var variantTitle = "_15-1m";
export var voided = "_15-u";